import { cloneDeep, isEmpty, isNumber, pickBy } from "lodash";
import { apiSlice } from "./apiSlice";
import store from "src/_store/store"
import { FEDEX_IDS } from "src/constants";

const getXlsUrl = () => {
    // const state = store.getState()
    let url = `/order/xls`
    // if (FEDEX_IDS.includes(state?.entities?.profile?.profile?.merchant?.id)) {
    //     url = `/order/xls-fedex`
    // }
    return url
}

const getGlobalFilterCriteria = (params, warehouseTypeArray = false) => {
    const state = store.getState()
    let customizations = cloneDeep(state?.entities?.customizations)
    let customizationsExistedData = pickBy(customizations, v => !isEmpty(v))
    if (!isEmpty(customizationsExistedData)) {
        if (!!customizationsExistedData?.warehouse) {
            if (warehouseTypeArray) {
                customizationsExistedData.warehouse = [customizationsExistedData?.warehouse?.id]
            } else {
                customizationsExistedData.warehouse = customizationsExistedData?.warehouse?.id
            }
        }
        return { ...params, ...customizationsExistedData }
    }
    return params
}

export const orderApi = apiSlice
    .enhanceEndpoints({ addTagTypes: ['ORDER'] })
    .injectEndpoints({
        keepUnusedDataFor: 1,
        endpoints: builder => ({
            getOrders: builder.query({
                query: (params) => ({
                    url: '/order',
                    method: 'GET',
                    params: getGlobalFilterCriteria(params)
                }),
                providesTags: (result, _, __) =>
                    result
                        ? [
                            ...result?.docs.map(({ id }) => ({ type: "ORDER", id })),
                            { type: "ORDER", id: "ORDER-PARTIAL-LIST" },
                        ]
                        : [{ type: "ORDER", id: "ORDER-PARTIAL-LIST" }],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getOrdersByOrderType: builder.query({
                query: ({ orderType, zoneId, params }) => ({
                    url: `/order/${orderType}/${zoneId}`,
                    method: 'GET',
                    params: getGlobalFilterCriteria(params)
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getOrdersByTaskId: builder.query({
                query: ({ id, params }) => ({
                    url: `/order/task_orders/${id}`,
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getOrderById: builder.query({
                query: (id) => ({
                    url: `/order/${id}`,
                    method: 'GET'
                }),
                providesTags: (_, __, id) => [{ type: 'ORDER', id }],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getOrderByIdPublic: builder.query({
                query: (id) => ({
                    url: `/user/order/${id}`,
                    method: 'GET'
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getWarehousesOrdersCount: builder.query({
                query: (params) => ({
                    url: '/order/warehouse_orders_count',
                    method: 'GET',
                    params: getGlobalFilterCriteria(params)
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getZonesOrdersCount: builder.query({
                query: (params) => ({
                    url: `/order/zones_orders`,
                    method: 'GET',
                    params: getGlobalFilterCriteria(params)
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getOrdersByWarehouseId: builder.query({
                query: ({ warehouseId, params }) => ({
                    url: `/order/warehouse_orders/${warehouseId}`,
                    method: 'GET',
                    params: getGlobalFilterCriteria(params)
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getReturnedOrdersByWarehouseId: builder.query({
                query: ({ warehouseId, params }) => ({
                    url: `/order/warehouse_returns_orders/${warehouseId}`,
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            updateOrder: builder.mutation({
                query: ({ orderId, payload }) => {
                    return {
                        url: `/order/${orderId}`,
                        method: 'PUT',
                        body: { ...payload }
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            ordersFilter: builder.mutation({
                query: (payload) => {
                    if (isNumber(payload?.page)) payload.page = '' + payload?.page
                    return {
                        url: `/order/filter`,
                        method: 'POST',
                        body: getGlobalFilterCriteria(payload, true)
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            sendExcelFileToEmail: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/order/filterToXLS`,
                        method: 'POST',
                        body: getGlobalFilterCriteria(payload, true)
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            importOrdersFromSpreadsheet: builder.mutation({
                query: (payload) => {
                    const url = getXlsUrl()
                    return {
                        url,
                        method: 'POST',
                        body: { ...payload }
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            assignWarehouseToOrders: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/order/shipping-company-warehouse`,
                        method: 'PUT',
                        body: { ...payload }
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            sendPendingOrdersExcelFileToEmail: builder.query({
                query: (params) => {
                    return {
                        url: `/pending/filterToXLS`,
                        method: 'GET',
                        params: getGlobalFilterCriteria(params)
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            assignOrdersToAnotherCompany: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/order/moment`,
                        method: 'POST',
                        body: payload
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            assignOrderToDriverForReturn: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/order/assign-driver-for-return`,
                        method: 'POST',
                        body: payload
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            pickReturnedOrder: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/order/merchant-warehouse/pick`,
                        method: 'POST',
                        body: payload
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            updateOrderStatus: builder.mutation({
                query: ({ orderId, payload }) => {
                    return {
                        url: `/order/update-status/${orderId}`,
                        method: 'PUT',
                        body: { ...payload }
                    }
                },
                invalidatesTags: (_, __, { orderId }) => [
                    { type: 'ORDER', id: orderId },
                    { type: 'ORDER', id: 'ORDER-PARTIAL-LIST' },
                ],
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            assignOrdersToAnotherCompany: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/order/moment`,
                        method: 'POST',
                        body: payload
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            assignOrderToDriverForReturn: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/order/assign-driver-for-return`,
                        method: 'POST',
                        body: payload
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            pickReturnedOrder: builder.mutation({
                query: (payload) => {
                    return {
                        url: `/order/merchant-warehouse/pick`,
                        method: 'POST',
                        body: payload
                    }
                },
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getOrderZoneHistory: builder.query({
                query: (orderId) => {
                    return {
                        url: `/order/zone-history/${orderId}`,
                        method: 'GET',
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getOrderStatusHistory: builder.query({
                query: (orderId) => {
                    return {
                        url: `/order/status-track/${orderId}`,
                        method: 'GET',
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getOrdersList: builder.query({
                query: (params) => ({
                    url: '/order/list',
                    method: 'GET',
                    params
                }),
                providesTags: (result, _, __) =>
                    result
                        ? [
                            ...result?.docs.map(({ id }) => ({ type: "ORDER", id })),
                            { type: "ORDER", id: "ORDER-PARTIAL-LIST" },
                        ]
                        : [{ type: "ORDER", id: "ORDER-PARTIAL-LIST" }],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            assignOrdersToShippingComapny: builder.mutation({
                query: (payload) => ({
                    url: '/order/assign-shipping_company',
                    method: 'POST',
                    body: { ...payload }
                }),
                invalidatesTags: (_, __, { orderId }) => [
                    { type: 'ORDER', id: orderId },
                    { type: 'ORDER', id: 'ORDER-PARTIAL-LIST' },
                ],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getPrintableAWB: builder.mutation({
                query: (payload) => ({
                    url: '/order/generate-pdf',
                    method: 'POST',
                    body: { ...payload }
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            checkIfAwbExist: builder.query({
                query: (id) => ({
                    url: `/order/check-zid-pdf/${id}`,
                    method: 'GET',
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            reuploadAwb: builder.mutation({
                query: (orderId) => ({
                    url: `/order/resend-zid-pdf/${orderId}`,
                    method: 'PUT',
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            deleteOrder: builder.mutation({
                query: (orderId) => ({
                    url: `/order/${orderId}`,
                    method: 'DELETE',
                }),
                invalidatesTags: (_, __, orderId) => [
                    { type: 'ORDER', id: orderId },
                    { type: 'ORDER', id: 'ORDER-PARTIAL-LIST' },
                ],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedOrders: builder.query({
                query: (params) => ({
                    url: "/archived-order/filter",
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedOrdersXls: builder.query({
                query: (params) => ({
                    url: "/archived-order/filterToXLS",
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedOrderById: builder.query({
                query: (id) => ({
                    url: `/archived-order/${id}`,
                    method: 'GET'
                }),
                providesTags: (_, __, id) => [{ type: 'ORDER', id }],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedOrdersByTaskId: builder.query({
                query: ({ id, params }) => ({
                    url: `/archived-order/task_orders/${id}`,
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedOrderZoneHistory: builder.query({
                query: (orderId) => {
                    return {
                        url: `/archived-order/zone-history/${orderId}`,
                        method: 'GET',
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getArchivedOrderStatusHistory: builder.query({
                query: (orderId) => {
                    return {
                        url: `/archived-order/status-track/${orderId}`,
                        method: 'GET',
                    }
                },
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
        })
    })

export const {
    useGetOrdersQuery,
    useGetOrdersByTaskIdQuery,
    useLazyGetWarehousesOrdersCountQuery,
    useGetZonesOrdersCountQuery,
    useLazyGetZonesOrdersCountQuery,
    useGetOrdersByWarehouseIdQuery,
    useLazyGetOrdersByWarehouseIdQuery,
    useLazyGetReturnedOrdersByWarehouseIdQuery,
    useGetOrderByIdQuery,
    useUpdateOrderMutation,
    useSendExcelFileToEmailMutation,
    useGetOrderByIdPublicQuery,
    useOrdersFilterMutation,
    useGetOrdersByOrderTypeQuery,
    useImportOrdersFromSpreadsheetMutation,
    useAssignWarehouseToOrdersMutation,
    useLazySendPendingOrdersExcelFileToEmailQuery,
    useAssignOrdersToAnotherCompanyMutation,
    useAssignOrderToDriverForReturnMutation,
    usePickReturnedOrderMutation,
    useUpdateOrderStatusMutation,
    useLazyGetOrderZoneHistoryQuery,
    useGetOrderStatusHistoryQuery,
    useGetOrdersListQuery,
    useAssignOrdersToShippingComapnyMutation,
    useGetPrintableAWBMutation,
    useCheckIfAwbExistQuery,
    useReuploadAwbMutation,
    useDeleteOrderMutation,
    useLazyGetArchivedOrdersQuery,
    useLazyGetArchivedOrdersXlsQuery,
    useGetArchivedOrderByIdQuery,
    useGetArchivedOrdersByTaskIdQuery,
    useLazyGetArchivedOrderZoneHistoryQuery,
    useGetArchivedOrderStatusHistoryQuery,
} = orderApi
